export default __webpack_public_path__ + "static/media/select2.7b6f5f6c.svg";